const CLOUDSTORE_PREFIX = "https://cloud-store" + process.env.VUE_APP_DOMAIN;
const PREFIX = "https://course" + process.env.VUE_APP_DOMAIN;
const PLUS_PREFIX = "https://plus" + process.env.VUE_APP_DOMAIN;
const TICKETS_PREFIX = "https://tickets" + process.env.VUE_APP_DOMAIN;
const KUNGFU_PREFIX = "https://kongfu-service" + process.env.VUE_APP_DOMAIN;
const PROJECT_PREFIX = "https://project-service" + process.env.VUE_APP_DOMAIN;
const PASSPORT_PREFIX = "https://passport" + process.env.VUE_APP_DOMAIN;
const VERSION = "V0.0.1";

export default {
  version: VERSION,

  userInfo: `${PASSPORT_PREFIX}/api/setting/profile`,

  qiniuUrl: "https://up.qiniup.com",
  qiniuConfig: `${CLOUDSTORE_PREFIX}/api/file/config`,
  qiniuToken: `${CLOUDSTORE_PREFIX}/api/file/qiniu-upload-token`,
  qiniuStore: `${CLOUDSTORE_PREFIX}/api/file/qiniu-file-store`,
  qiniuPlusConfig: `${PLUS_PREFIX}/api/file/config`,
  qiniuPlusToken: `${PLUS_PREFIX}/api/file/qiniu-upload-token`,
  qiniuPlusStore: `${PLUS_PREFIX}/api/file/qiniu-file-store`,

  plusFile: `${PLUS_PREFIX}/api/file/sub-file-store`,
  projectFile: `${PROJECT_PREFIX}/api/file/sub-file-store`,

  plusClassItem: id => `${PLUS_PREFIX}/api/user_center/learn/ying/goods/${id}`,
  plusContent: id =>
    `${PLUS_PREFIX}/api/user_center/learn/ying/goods/content/${id}`,
  plusStudy: `${PLUS_PREFIX}/api/study`,
  plusLog: `${PLUS_PREFIX}/api/logs`,
  plusLogQuery: `${PLUS_PREFIX}/api/log/query`,
  plusCourse: id => `${PLUS_PREFIX}/api/courses/${id}`,
  plusHomework: `${PLUS_PREFIX}/api/homeworks`,
  plusHomeworkItem: id => `${PLUS_PREFIX}/api/homeworks/${id}`,
  plusHomeworkComment: id => `${PLUS_PREFIX}/api/homeworks/${id}/comment`,
  plusGraduation: `${PLUS_PREFIX}/api/graduation-works`,
  plusGraduationItem: id => `${PLUS_PREFIX}/api/graduation-works/${id}`,
  plusCertificate: `${PLUS_PREFIX}/api/certificate`,
  plusCertificates: `${PLUS_PREFIX}/api/certificates`,
  plusClockIn: `${PLUS_PREFIX}/api/punch-cards`,

  courseItem: id => `${PREFIX}/api/web/course/${id}`,
  courseAdd: id => `${PREFIX}/api/web/course/${id}/add`,
  courseRecord: (courseId, lessonId) =>
    `${PREFIX}/api/web/course/${courseId}/lesson/${lessonId}/record`,

  workOrders: `${TICKETS_PREFIX}/api/web/work-orders?from=jiker`,

  kungfuPathItem: id =>
    `${KUNGFU_PREFIX}/api/web/study-center/study-paths/${id}`,
  kungfuPathTaskFinish: (pathId, taskId) =>
    `${KUNGFU_PREFIX}/api/web/study-center/study-paths/${pathId}/tasks/${taskId}/finish`,
  kungfuPathTaskFeedback: (pathId, taskId) =>
    `${KUNGFU_PREFIX}/api/web/study-center/study-paths/${pathId}/tasks/${taskId}/feedback`,
  projectItem: id => `${PLUS_PREFIX}/api/projects/${id}`,
  coursePlainItem: id => `${KUNGFU_PREFIX}/api/web/courses/${id}`,
  projectPlainItem: id => `${KUNGFU_PREFIX}/api/web/projects/${id}`,

  projectPages: id => `${PROJECT_PREFIX}/api/web/my-projects/${id}/pages`,
  projectPagesContents: (projectId, sectionId) =>
    `${PROJECT_PREFIX}/api/web/my-projects/${projectId}/pages/${sectionId}/contents`,
  projectPagesProgress: (projectId, sectionId) =>
    `${PROJECT_PREFIX}/api/web/my-projects/${projectId}/pages/${sectionId}/progresses`,
  projectPagesHomeworksAll: (projectId, sectionId) =>
    `${PROJECT_PREFIX}/api/web/my-projects/${projectId}/pages/${sectionId}/homeworks/all`,
  projectPagesHomeworks: (projectId, sectionId) =>
    `${PROJECT_PREFIX}/api/web/my-projects/${projectId}/pages/${sectionId}/homeworks`,
  projectPagesHomeworksItem: (projectId, sectionId, homeworkId) =>
    `${PROJECT_PREFIX}/api/web/my-projects/${projectId}/pages/${sectionId}/homeworks/${homeworkId}`,
  projectPagesHomeworksItemComments: (projectId, sectionId, homeworkId) =>
    `${PROJECT_PREFIX}/api/web/my-projects/${projectId}/pages/${sectionId}/homeworks/${homeworkId}/comments`
};
